import React from 'react';
import DateRange from './Inputs/DateRange/DateRange';
import Select from './Inputs/Select/Select';
import RadioGroup from './Inputs/RadioGroup/RadioGroup';
import Multi from './Inputs/Multi/Multi';

export default function Field({ cfg, value, onChange, options = [], inputClassName }) {
    switch (cfg.type) {
        case 'daterange':
            return (
                <DateRange
                    label={cfg.label ?? ''}
                    value={value}
                    onChange={(next) => {
                        if (typeof cfg.onMultiChange === 'function') {
                            cfg.onMultiChange({ start: next?.start ?? '', end: next?.end ?? '' });
                        } else if (typeof onChange === 'function') {
                            onChange(next);
                        }
                    }}
                    withTime={cfg.withTime}
                    enforceOrder={cfg.enforceOrder}
                    min={cfg.min}
                    max={cfg.max}
                    startPlaceholder={cfg.startPlaceholder}
                    endPlaceholder={cfg.endPlaceholder}
                    inputClassName={inputClassName}
                />
            );
        case 'input':
            return (
                <input
                    className={inputClassName}
                    placeholder={cfg.placeholder}
                    value={value ?? ''}
                    onChange={(e) => onChange(e.target.value)}
                    type={cfg.inputType || 'text'}
                />
            );
        case 'date':
            return (
                <input
                    className={inputClassName}
                    type="date"
                    value={value ?? ''}
                    onChange={(e) => onChange(e.target.value)}
                />
            );
        case 'select': {
            return (
                <Select
                    label={cfg.label ?? ''}
                    value={value}
                    onChange={onChange}
                    options={options}
                    {...(cfg.selectProps || {})}
                />
            );
        }
        case 'radio':
            return (
                <RadioGroup
                    value={value}
                    onChange={onChange}
                    options={options}
                />
            );
        case 'multi': {
            const items = Array.isArray(value) ? value : [];
            return (
                <Multi
                    required={cfg.required}
                    items={items}
                    onChange={onChange}
                    options={options}
                    inputType={cfg.inputType}
                    inputPlaceholder={cfg.inputPlaceholder}
                    labelLeft={cfg.leftLabel}
                    labelRight={cfg.rightLabel}
                />
            );
        }
        default:
            return null;
    }
}